import { Nullable } from './nullable-type';
import { SubticketTypeField } from './subticket-type-field';

export class SubticketTypeFieldValue extends SubticketTypeField {
  public Value: Nullable<string>;
}
